export default __webpack_public_path__ + "static/media/Simba_Gouache_Painting.19553fb3.jpg";